export interface StartStreamingSessionRequest {
  roomName: string;
  //maxParticipants: number;
  emptyTimeoutSeconds: number;
  outputPath: string;
  hostIdentity: string;
  hostName: string;
  enableHlsStreaming: boolean;
  courtLocation: string;
  courtRoom: string;
  microphone: string;
  recordingSource: string;
  sourceSystem: string;
  language: string;
  translateToEnglish: boolean;
  audioChannels: number;
  orgExtId: string;
  userId : number;
  caseNumber?: string;
  hearingDateTime?: Date | string;
  startedAt?: string;
  judgeFirstName?: string;
  judgeLastName?: string;
  // Case Management
  caseId?: number;
  caseProfileName?: string;
  casePeople?: string;
  // Dynamic form field values as an opaque JSON bag (no backend change needed for new form types).
  formData?: string;
  deptExtId: string;
}

export interface StartStreamingSessionResponse {
  success: boolean;
  message: string;
  roomSid: string;
  roomName: string;
  egressId: string;
  hostToken: string;
  hostName: string;
  hostRoomUrl: string;
  serverUrl: string;
  createdAt: string;
  recordingSessionId : number;
  caseDetailsId?: number;
}
export interface CreateNewCaseRequest {
  recordingSessionId: number;
  roomName: string;
  caseId?: number | null;
  caseNumber: string | null;
  judgeName: string | null;
  formData: string | null;
  startedAt?: Date | null;
}
export interface UpdateCaseRequest {
  caseDetailsId: number;
  recordingSessionId: number;
  roomName: string;
  caseId?: number | null;
  caseNumber: string | null;
  judgeName: string | null;
  formData: string | null;
  userName: string;
  userId: number | null;
}
export interface StreamingDetails {
  roomName: string;
}
export interface StartTranscriptionRequest {
  roomName: string;
  agentName: string;
  engine: string;
  language: string;
  enableDiarization: boolean;
  sessionId: string;
  translateToEnglish: boolean;
}

export interface StartTranscriptionResponse {
  success: boolean;
  message: string;
  dispatchId: string;
  sessionId: string;
  roomName: string;
  agentName: string;
  engine: string;
  language: string;
  enableDiarization: boolean;
  startedAt: string;
}

export interface StopTranscriptionRequest {
  roomName: string;
  dispatchId?: string;
  sessionId?: string;
}

export interface StopTranscriptionResponse {
  success: boolean;
  message: string;
  roomName: string;
  dispatchId: string;
  sessionId: string;
  stoppedAt: string;
}

export interface StopStreamingSessionRequest {
  roomName: string;
  //egressId: string;
  deleteRoom: boolean;
  recordingDetails : string;
}
export interface GetFileUploadModel {
  roomName: string;
  fileName: string;
  contentType: string;
  fileType : string;
}


export interface StopStreamingSessionResponse {
  success: boolean;
  message: string;
  roomName: string;
  egressId: string;
  recordingStopped: boolean;
  roomDeleted: boolean;
  stoppedAt: string;
}
export enum RecordingSource {
  Desktop = 'Desktop',
  Web = 'Web',
  Mobile = 'Mobile'
}
export interface TranscriptionSegment {
  startTime: number;
  endTime: number;
  language: string;
  speaker: string;
  speakerKey: string;
  speakerNumber: number;
  text: string;
  timestamp: number;
  translatedText: string;
  translationTarget: string;
}
export interface Annotations {
  id?: number;               // Matches int? (Optional property)
  timeStamp: string;         // DateTime maps to string in TypeScript/JSON
  speaker: string;           // Maps directly to string
  comments: string;          // Maps directly to string
  recordingSessionId: number;// int maps to number
  sourceType: string;        // Maps directly to string
  audioTime: number;         // int maps to number
  isEditing?: boolean;
  caseDetailsId?: number | null;
  // isNewManualRow?: boolean;  // UI state for new manual rows
}
/** A person who can be tagged on an annotation, taken from a reference-linked form field. */
export interface AnnotationSpeaker {
  role: string;   // The field's referenceField (e.g. Judge, Defendant); drives the letter shortcut
  label: string;  // The field's label, shown next to the name in the Speakers menu
  name: string;   // The field's value; becomes the annotation row's speaker
}
export interface AnnotationDialogModel {
      caseNumber: string;
      hlsUrl: string;
      startTimestamp: string;
      endTimestamp: string;
      recordingId: number;
      judgeName: string;
      hearingDate: string;
      sessionId: string;
      caseDetailsId?: number;
}
